// src/components/Events/EventsHeader.tsx

import React from "react";
import TuneIcon from "@mui/icons-material/Tune";
import SearchIcon from "@mui/icons-material/Search";
import {
  TopBar,
  TopBarLeft,
  CountLabel,
  FilterIconContainer,
  SearchContainer,
  CreateNewEvent,
} from "./NewEvents.styles";

interface EventsHeaderProps {
  userType: string;
  pastCount: number;
  upcomingCount: number;
  handleOpenCreateEvent: () => void;
  onSearchChange: (text: string) => void;
  publicUserId?: number;
}

const EventsHeader: React.FC<EventsHeaderProps> = ({
  userType,
  pastCount,
  upcomingCount,
  handleOpenCreateEvent,
  onSearchChange,
  publicUserId,
}) => {
  return (
    <TopBar>
      <TopBarLeft>
        {!publicUserId && <CountLabel>({pastCount}) Past</CountLabel>}
        <CountLabel>({upcomingCount}) Upcoming</CountLabel>
        <FilterIconContainer>
          <TuneIcon style={{ color: "#FE2F67", fontSize: "20px" }} />
        </FilterIconContainer>
        <SearchContainer>
          <div className="search-input-wrapper">
            <SearchIcon className="search-icon" />
            <input
              type="text"
              placeholder="Search Events..."
              onChange={(e) => onSearchChange(e.target.value)}
              className="search-input"
            />
          </div>
        </SearchContainer>
      </TopBarLeft>

      {userType === "organization" && !publicUserId && (
        <CreateNewEvent onClick={handleOpenCreateEvent}>
          Create new event
        </CreateNewEvent>
      )}
    </TopBar>
  );
};

export default EventsHeader;
